<template>
    <div class="row">
        <notifications group="foo" position="top right" />

        <div v-if='load === "send_email"' class="col-lg-12 col-xs-12">
          <div class="row">
              <SendEmail v-if="!send" :form="form" :selected="selected" :amazonUrl="s3_url" :count_selected="count_selected" />
          </div>
        </div>

        <div class="col-lg-12 col-xs-12">
            <div class="spinner" v-if="load === 'loading'">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>

            <div v-if="load === '404'" class="m-t-30">
                <div class="title-form">
                    <h4> The file does not exist </h4>
                </div>
            </div>
            <h2 v-if="load === '200'">Leads enriched</h2>
            <div class="table-wrapper" v-if="load === '200'">
                <table>
                    <thead>
                        <tr>
                            <th><input type="checkbox" v-model="checked"></th>
                            <th v-for="column in columns" v-bind:key="column">
                                {{column}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(lead, index) in leads" v-bind:key="index">
                            <td><input type="checkbox" v-model="selected[index].selected" :checked="selected[index].selected"></td>
                            <td v-for="(le, index) in lead" v-bind:key="index">
                                {{le}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="left inline-block" v-if="loadMore">
                <div class="my-btn inline-block" @click="getMoreleads">
                    <div class="btn-text-details btn-txt">
                        <span> Load more Leads </span>
                    </div>
                </div>
            </div>
            <div class="right inline-block hidden-xs" v-if="load === '200'">
                <div class="inline-block" v-if="!processing">
                    <div class="field">
                        <input type="email" v-model="webhook_url"  placeholder="Webhook URL" class="input-form" required>
                        <label for="email">Webhook URL</label>
                    </div>
                </div>
                <div class="my-btn inline-block" @click="sendWebhook" v-if="!processing">
                    <div class="btn-text-details btn-txt">
                        <span> Send webhook </span>
                    </div>
                </div>
            </div>

            <div class="row visible-xs" v-if="load === '200'">
              <div class="col-md-12">
                <div class="right">
                    <div class="inline-block" v-if="!processing">
                      <div class="field">
                          <input type="email" v-model="webhook_url"  placeholder="Webhook URL" class="input-form" required>
                          <label for="email">Webhook URL</label>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row visible-xs" v-if="load === '200'">
              <div class="col-md-12">
                <div class="right">
                    <div class="my-btn inline-block" @click="sendWebhook" v-if="!processing">
                        <div class="btn-text-details btn-txt">
                            <span> Send webhook </span>
                        </div>
                    </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="load === '200' && !email_send">
              <div class="col-md-12">
                <div class="right">
                    <div class="my-btn inline-block" @click="emailLink">
                        <div class="btn-text-details btn-txt">
                            <span> Send Email </span>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Papa from 'papaparse'
import { mapMutations } from 'vuex'
import SendEmail from '@/components/SendEmail.vue'

export default {
  name: 'csv_details',
  components: {
    SendEmail
  },
  data () {
    return {
      leads: [],
      columns: [],
      limit: 250,
      checked: false,
      selected: {},
      load: 'loading',
      loadMore: false,
      webhook_url: '',
      processing: false,

      // Send email data
      email_send: false,
      file: false,
      form: {
        from: '',
        subject: '',
        cc: '',
        snippet: '',
        name: ''
      },
      s3_url: null,
      send: false,
      response_gmail: null,
      email: '',
      count_selected: 0
    }
  },
  watch: {
    checked (val) {
      let leads = this.selected
      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          leads[key].selected = val
        }
      }
    }
  },
  mounted () {
    this.getLeads()
    this.response_gmail = this.user_data.gmail_credentials
  },
  methods: {
    ...mapMutations('user', [
      'setUrl',
      'setLeadSelected'
    ]),
    setSend (val) {
      this.send = val
    },
    setLoad (val) {
      this.load = val
    },
    setEmailSend (val) {
      this.email_send = true
    },
    // end email methods
    sendWebhook () {
      let leadSelected = false
      for (const key in this.selected) {
        if (this.selected.hasOwnProperty(key)) {
          const element = this.selected[key]
          if (element.selected) {
            leadSelected = true
          }
        }
      }
      if (!leadSelected || !this.webhook_url.length) {
        let message = !leadSelected ? 'Please select at least one record' : 'Please enter a valid webhook URL'
        this.$notify({
          group: 'foo',
          title: 'Webhook error',
          type: 'error',
          text: message,
          duration: 10000
        })
      } else {
        try {
          new URL(this.webhook_url)
          this.sendData()
        } catch (_) {
          this.$notify({
            group: 'foo',
            title: 'Webhook error',
            type: 'error',
            text: 'invalid URL',
            duration: 10000
          })
        }
      }
    },
    emailLink () {
      let leadSelected = false
      this.count_selected = 0

      for (const key in this.selected) {
        if (this.selected.hasOwnProperty(key)) {
          const element = this.selected[key]
          if (element.selected) {
            this.count_selected = this.count_selected + 1
            leadSelected = true
          }
        }
      }
      if (!leadSelected) {
        let message = 'Please select at least one record'
        this.$notify({
          group: 'foo',
          title: 'Error',
          type: 'error',
          text: message,
          duration: 10000
        })
      } else {
        if (this.user_data.gmail_credentials) {
          // this.setLeadSelected(this.selected)
          // this.$router.push({ name: 'send_email' })
          this.getEmails()
        } else {
          this.$router.push({ name: 'integration', query: { csv: this.$route.params.id } })
        }
      }
    },
    getEmails () {
      this.$http.get('/api/user/gmail/emails').then((res) => {
        this.form.from = res.data.emailAddress
        this.form.name = res.data.name
        this.load = 'send_email'
      }).catch((e) => {
        if (e.status === 500) {
          this.$notify({
            group: 'foo',
            title: 'Error',
            type: 'error',
            text: 'Please try again',
            duration: 10000
          })
        } else {
          this.$router.push({ name: 'integration', query: { csv: this.$route.params.id } })
        }
      })
    },
    sendData () {
      this.$http.post(`/api/webhook/${this.$route.params.id}`, {
        'url': this.webhook_url,
        'data': this.selected
      }).then((_) => {
        this.processing = true
        this.$notify({
          group: 'foo',
          title: 'Webhook send',
          type: 'success',
          text: 'We are processing your file',
          duration: 10000
        })
      })
    },
    getMoreleads () {
      this.limit += 50
      this.getLeads()
    },
    getLeads () {
      this.$http.get(`/api/csv/${this.$route.params.id}/${this.limit}`).then((res) => {
        let leads = res.data.data
        this.setUrl(res.data.url)
        this.s3_url = res.data.url
        if (this.leads.length === leads.length) {
          this.loadMore = false
        } else {
          // this.loadMore = true
          this.loadMore = false
        }
        this.leads = leads
        this.columns = res.data.columns
        let selected = {}
        for (let index = 0; index < this.leads.length; index++) {
          selected[index] = {
            selected: false
          }
        }
        this.selected = selected
        this.load = '200'
      }).catch((err) => {
        this.load = '404'
      })
    }
  },
  computed: {
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-txt {
    height: 30px;
    span {
        display: inline-block;
        vertical-align: middle;
        margin-top: 5px
    }
}
.btn-txt:hover {
    background-color: $light-1
}
.inline-block {
    display: inline-block;
    margin-top: 10px;
    vertical-align: middle;
}
.left {
    float: left;
    margin-top: 20px
}
.right {
    float: right;
}
.table-wrapper {
    max-width: 100%;
    overflow: scroll;
}

table {
    position: relative;
    border: 1px solid #ddd;
    border-collapse: collapse;
}

td, th {
    white-space: nowrap;
    border: 1px solid #ddd;
    padding: 20px;
    text-align: left;
}

th {
    background-color: #eee;
    position: sticky;
    top: -1px;
    z-index: 2;

    &:first-of-type {
        left: 0;
        z-index: 3;
    }
}

tbody tr td:first-of-type {
    background-color: #eee;
    position: sticky;
    left: -1px;
    text-align: left;
}

.snippet-select {
  padding-top: 0;

}

.snippet-field {
  margin-bottom: 0;
  margin-top: 2em;
}
</style>
